import { Tabs as MuiTabs } from '@fortune-ui'
import { type TabsProps as MuiTabsProps } from '@mui/material'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'

export interface TabData {
  label: string
  value: number | string
  disabled?: boolean
}
export interface TabsProps<T extends TabData['value']> extends Omit<MuiTabsProps, 'value'> {
  tabData: TabData[]
  value: T
  color: string
}

export function Tabs<T extends TabData['value']>(props: TabsProps<T>) {
  const { tabData, value, color, ...rest } = props
  const isWordPressMobile = useResponsive('wordpressMobile')

  return (
    <MuiTabs
      variant={isWordPressMobile ? 'fullWidth' : 'standard'}
      tabData={tabData}
      value={value}
      sx={{
        'mx': isWordPressMobile ? '-18px' : '0',
        '.MuiTabs-scroller .MuiTabs-indicator': {
          backgroundColor: color,
          height: '1px',
        },
        '.MuiTabs-scroller .Mui-selected': {
          color,
        },
        '.MuiTab-root': {
          color: colors.grey500,
        },
        '.MuiBox-root': {
          border: 'none',
        },
        'borderBottom': '1px solid #E9E9E9',
        'backgroundColor': colors.white,
        'borderRadius': isWordPressMobile ? 'none' : '8px 8px 0 0',
      }}
      {...rest}
    />
  )
}
